module.exports = __webpack_public_path__ + "media/stencils/framed_smt_stencils-afa0ba22.png";